// extracted by mini-css-extract-plugin
export default {"gallery":"c-o_gf","gallery__header":"c-o_gg","gallery__thumbs":"c-o_gh"};